export default __webpack_public_path__ + "static/media/iso-white.527c6378.png";